import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue-demi';
import { useToggle } from '@vueuse/core';
import { AbIcon } from '../';

interface Props {
  title: string;
  body: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbAccordionItem',
  props: {
    title: null,
    body: null
  },
  setup(__props: any) {



const isOpen = ref(false);
const toggleItem = useToggle(isOpen);

return { __sfc: true,isOpen, toggleItem, AbIcon }
}

})